import CloseIcon from "@mui/icons-material/Close";
import { Button, ButtonGroup, TextField } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import React, { useState } from "react";
import { useIntl } from "react-intl";
import SearchIcon from "@mui/icons-material/Search";
import Typography from "@mui/material/Typography";
import DeliveryDiningIcon from "@mui/icons-material/DeliveryDining";
import axios from "axios";
import configs from "../../Constants";
import ShoppingCartCheckoutIcon from '@mui/icons-material/ShoppingCartCheckout';

const StartOrderPopup = ({
  merchantData,
  containedIndex,
  handleOrderTypeTabClick,
  handleTableDetail,
  order,
  closeDialog,
  setOrder,
  setHoldOpen

}) => {
  console.log(order);
  const [searchResults, setSearchResults] = useState([]);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);
  const [showSelectedData, setShowSelectedData] = useState(false);
  const [existingData, setExistingData] = useState({});
  const { formatMessage: t, locale } = useIntl();
  const [name, setName] = useState(existingData ? existingData.Name : "");
  const [email, setEmail] = useState(existingData ? existingData.Email : "");

  const [address, setAddress] = useState(
    existingData ? existingData.Address : ""
  );
  const [showAddressDialog, setShowAddressDialog] = useState(false);
  const [customerDetail, setCustomerDetail] = useState(false);
  const [searchAttempted, setSearchAttempted] = useState(false);
  const [openPhone, setOpenPhone] = useState(false);
  const [custId, setCustId] = useState("");
  const [isCustomerFound, setIsCustomerFound] = useState(true);
  const [mobileNo, setMoblileNo] = useState("");
  const [phnumber, setPhnumber] = useState(
    existingData ? existingData.phoneNo : 0
  );
  const randomNumber = Math.floor(Math.random() * 1000000000);
  const customerID = custId;
  let userToken = sessionStorage.getItem("token")
    ? sessionStorage.getItem("token")
    : "";
  const getCustomerById = async (custId) => {
    if (custId) {
      const res = await axios.get(`${configs.authapi}/customer/${custId}`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      if (res.data.id) {
        handleCustomerSelect(res.data);
      }
    }
  }

  const handleSearchCustomer = async () => {
    if (!phnumber) {
      // console.log("📭 No phone number provided.");
      return;
    }

    try {
      // console.log("🔍 Searching customer with phone:", phnumber);

      setSearchAttempted(true);

      const res = await axios.post(
        `${configs.authapi}/user/customers/find`,
        { phone: phnumber },
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
          },
        }
      );

      // console.log("Full API response:", res);

      const customers = Array.isArray(res.data?.customers)
        ? res.data.customers
        : [];

      // console.log("Parsed customers array:", customers);

      setSearchResults(customers);
      setIsCustomerFound(customers.length > 0);

      if (customers.length > 0) {
        const firstCustomer = customers[0];
        setName(firstCustomer.firstName || "");
        setEmail(firstCustomer.email || "");
        setAddress(firstCustomer.address || "");
        setCustId(firstCustomer.id || firstCustomer._id);
      }
    } catch (err) {
      // console.log("Search error:", err?.response?.data || err.message);
      setSearchResults([]);
      setIsCustomerFound(false);
    }
  };
  // Add this new function to handle radio selection
  const handleCustomerSelect = (customer) => {
    setName(customer.firstName);
    setEmail(customer.email);
    setPhnumber(customer.phone);
    setCustId(customer.id);
    setAddress(customer.address);
    setIsCustomerFound(true);
  };

  const handleSaveCustomerSelection = () => {
    if (phnumber) {
      // Set customer details in state
      setMoblileNo(phnumber);
      setName(name);
      setAddress(address);

      // check whether the  order has items in it or not.
      const hasItems = order?.orderItems && order.orderItems.length > 0;

      // Initialize or update order object
      const updatedOrder = {
        ...(order || {}), // Create new order if none exists
        customerId: custId,
        customerPhone: phnumber,
        customerName: name !== "" ? name : phnumber,
        customerAddress: address,
        orderItems: order?.orderItems || [], // Ensure orderItems exists
      };

      console.log(updatedOrder);
      // Update order state
      setOrder(updatedOrder);

      // Reset UI states

    }
  };

  const handleAddCustomer = async () => {
    if (!phnumber) {
      console.log("Phone number is required");
      return;
    }
    const generatedEmail = email || `${phnumber}@nodomain.com`;
    try {
      const data = {
        email: generatedEmail,
        phone: phnumber,
        firstName: name || phnumber,
        lastName: "",
        address: address || "",
        password: phnumber,
        isEmailVerified: false,
        isPhoneVerified: false,
        referenceDetails: "",
        merchantCode: merchantData.merchantCode,
        userType: "CUSTOMER",
      };

      // console.log("Sending to API:", data);

      const res = await axios.post(`${configs.authapi}/user/customer`, data, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });

      // console.log("Customer added:", res.data);
      if (res?.data?.user?.customer?.id) {
        setCustId(res.data.user.customer.id);
      }
      setShowAddressDialog(false);
      setSearchResults([]);
      setSearchAttempted(false);
      setOpenPhone(false);
    } catch (error) {
      console.log(
        "Error adding customer:",
        error?.response?.data || error.message
      );
      console.log("Customer could not be added.");
    }
  };
  const handleDelivery = () => {
    // setOpenPhone(true);
  };
  const handleTakeAway = () => { };
  const handleDineIn = () => { };
  const handleNextClick = () => {
    // handlePayMode("CASH", order);
    // setCashPayDialog(false);
    if (order && custId) {
      order.customerId = custId;
      setOrder(order);
    }
    closeDialog();
    setPhnumber("");
    setName("");
    setEmail("");
    setAddress("");
    setCustId("");
    setSearchResults([]);
    setShowSelectedData(false);
    setIsCustomerFound(true);
  };

  return (
    <div>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <b>{t({ id: "new_order_details" })}</b>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => closeDialog()}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent
        style={{
          borderTop: "1px solid #ccc",
          borderBottom: "1px solid #ccc",
          padding: "0px 20px",
        }}
      >
        <div className={"dialog-row"} style={{ padding: "0px", justifyContent: "center" }}>
          <div >
            <ButtonGroup aria-label="Basic button group" id="order-type">
              {merchantData?.pos_enable_ss_eat_in && <Button
                variant={containedIndex === 3 ? "contained" : "outlined"}
                style={{
                  backgroundColor:
                    containedIndex === 3 ? "#F7C919" : "inherit",
                  borderColor: containedIndex === 3 ? "#F7C919" : "inherit",
                  color: containedIndex === 3 ? "black" : "inherit",
                  borderColor: "#F7C919",
                  display: "-webkit-inline-box!important"
                }}
                onClick={() => {
                  handleOrderTypeTabClick(3);
                }}
              >
                <img
                  height="40px"
                  alt=""
                  width="40px"
                  src="/images/eat_in.png"
                />
                <div>{t({ id: "eat_in" })}</div>
              </Button>}
              {merchantData?.pos_enable_take_away && <Button
                variant={containedIndex === 0 ? "contained" : "outlined"}
                style={{
                  backgroundColor:
                    containedIndex === 0 ? "#F7C919" : "inherit",
                  borderColor: containedIndex === 0 ? "#F7C919" : "inherit",
                  color: containedIndex === 0 ? "black" : "inherit",
                  borderColor: "#F7C919",
                }}
                onClick={() => {
                  handleOrderTypeTabClick(0);
                  handleTakeAway();
                }}
              >

                <img
                  height="40px"
                  width="40px"
                  alt=""
                  src="/images/take-out-2.png"
                />
                {t({ id: "take_away" })}
              </Button>}
              {merchantData?.pos_enable_dineIn && <Button
                variant={containedIndex === 1 ? "contained" : "outlined"}
                style={{
                  backgroundColor:
                    containedIndex === 1 ? "#F7C919" : "inherit",
                  borderColor: containedIndex === 1 ? "#F7C919" : "inherit",
                  color: containedIndex === 1 ? "black" : "inherit",
                  borderColor: "#F7C919",
                }}
                onClick={() => {
                  handleOrderTypeTabClick(1);
                  handleDineIn();
                  handleTableDetail();
                }}
              >
                <img
                  height="40px"
                  width="40px"
                  alt=""
                  src="/images/tableOrder.png"
                />
                {t({ id: "table_order" })}
              </Button>}
              {merchantData?.pos_enable_delivery && <Button
                variant={containedIndex === 2 ? "contained" : "outlined"}
                style={{
                  backgroundColor:
                    containedIndex === 2 ? "#F7C919" : "inherit",
                  borderColor: containedIndex === 2 ? "#F7C919" : "inherit",
                  color: containedIndex === 2 ? "black" : "inherit",
                  borderColor: "#F7C919",
                }}
                onClick={() => {
                  handleOrderTypeTabClick(2);
                  handleDelivery();
                }}
              >
                <DeliveryDiningIcon
                  style={{ height: "30px", width: "30px" }}
                />
                {t({ id: "delivery" })}
              </Button>}

              {true && <Button
                variant={containedIndex === 5 ? "contained" : "outlined"}
                style={{
                  backgroundColor:
                    containedIndex === 5 ? "#F7C919" : "inherit",
                  borderColor: containedIndex === 5 ? "#F7C919" : "inherit",
                  color: containedIndex === 5 ? "black" : "inherit",
                  borderColor: "#F7C919",
                }}
                onClick={() => {
                  handleOrderTypeTabClick(5);
                  handleDelivery();
                }}
              >
                <ShoppingCartCheckoutIcon
                  style={{ height: "30px", width: "30px" }}
                />
                {t({ id: "refund" })}
              </Button>}

            </ButtonGroup>

            <DialogContent dividers style={{ padding: "20px, 5px" }} id="customer-find">
              <h4 style={{ textAlign: "left", margin: "5px" }}>Customer Detail:</h4>
              <span style={{ margin: "5px", fontSize: "0.8em" }}>(Optional except delivery)</span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >

                <input
                  type="text"
                  placeholder="Find Mobile Number"
                  value={phnumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, "");
                    setPhnumber(value);
                  }}
                  className="number_input"
                  inputMode="numeric"
                  pattern="[0-9]*"
                  maxLength={15}
                  onKeyPress={(e) => e.key == 'Enter' && handleSearchCustomer(e)}
                  style={{
                    padding: "5px",
                    marginLeft: "10px",
                    fontSize: "1em",
                  }}
                />

                <button
                  onClick={handleSearchCustomer}
                  onSubmit={handleSearchCustomer}
                  type="submit"
                  disabled={!phnumber || phnumber < 100 ? true : false}
                  style={{
                    marginLeft: "10px",
                    borderRadius: "5px",
                    background: "#000",
                    color: "#fff",
                    width: "80px",
                    cursor: "pointer"
                  }}
                >
                  <SearchIcon />
                </button>
              </div>


              {searchAttempted && searchResults.length > 0 && (
                <div style={{ margin: "20px" }}>
                  <Typography variant="subtitle1">
                    Select Existing Customer:
                  </Typography>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    {searchResults.map((customer) => (
                      <div
                        key={customer.id || customer._id}
                        style={{ display: "flex", alignItems: "center" }}
                        onClick={() => handleCustomerSelect(customer)}

                      >
                        <input
                          type="radio"
                          checked={customer.id == custId}
                          id={customer.id || customer._id}
                          name="customerSelect"
                          style={{ fontSize: "1.3em", padding: "4px" }}
                        />
                        <label
                          htmlFor={customer.id || customer._id}
                          style={{ marginLeft: "10px" }}
                        >
                          {customer.firstName} - {customer.phone}
                          {customer.address && ` - ${customer.address}`}
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {searchAttempted && searchResults.length === 0 && (
                <>
                  <div
                    style={{
                      color: "#f44336",
                      padding: "8px 16px",
                      marginTop: "1px",
                      borderRadius: "4px",
                      marginRight: "10px",
                      fontSize: "11px"
                    }}
                  >
                    No Customer found with this number, Please Add as New customer.
                  </div>

                  <div style={{ padding: "20px" }}>
                    <TextField
                      type="text"
                      label="Customer Name"
                      placeholder="Enter Name"
                      value={name}
                      onChange={(e) => {
                        setName(e.target.value);
                      }}
                      className="number_input"

                    />
                    <TextField
                      fullWidth
                      multiline
                      rows={3}
                      label="Delivery Address"
                      value={address}
                      onChange={(e) => setAddress(e.target.value)}
                      variant="outlined"
                      style={{ marginBottom: "20px", marginTop: "10px" }}
                    />
                  </div>
                </>
              )}
              <div
                style={{
                  display: "flex",
                  padding: "10px",
                  justifyContent: "space-between",
                }}
              >
                {searchAttempted && searchResults.length === 0 && (
                  <Button
                    className="save-btn btnDialog-Fill"
                    variant="contained"
                    color="success"
                    onClick={handleAddCustomer}
                  >
                    SAVE CUSTOMER
                  </Button>
                )}

                {searchAttempted && searchResults.length > 0 && (
                  <Button
                    variant="contained"
                    onClick={handleSaveCustomerSelection}
                    style={{
                      width: "50px",
                      textAlign: "center",
                      background: "#f7c919",
                      padding: "5px 50px",
                    }}
                  >
                    SELECT
                  </Button>
                )}
              </div>
            </DialogContent>
          </div>
        </div>

      </DialogContent>
      <DialogActions>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
            width: "100%",
          }}
        >
          <Button
            variant="outlined"
            onClick={() => {
              setHoldOpen(true);
              closeDialog();
            }}
          >
            {t({ id: "resume" })}
          </Button>
          <Button
            variant="outlined"
            color="error"
            onClick={() => closeDialog()}
          >
            {t({ id: "cancel" })}
          </Button>
          <Button
            variant="contained"
            color="success"
            onClick={handleNextClick}
            disabled={containedIndex == 2 && (!order || !order?.customerId)}
          >
            {t({ id: "Next" })}
          </Button>
        </div>
      </DialogActions>
    </div>
  );
};

export default StartOrderPopup;
